import { render, staticRenderFns } from "./BottomBarManager.vue?vue&type=template&id=fc514b9e"
import script from "./BottomBarManager.vue?vue&type=script&lang=js"
export * from "./BottomBarManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports